export default __webpack_public_path__ + "static/media/cross.d1663af3.svg";